import PropTypes from 'prop-types';
import React from 'react';

import {
  CheckMark,
  TranslationProvider,
} from '@resy/ui-kitchen';

import './Category.scss';

export const NotRequired = () => (
  <TranslationProvider translationKey="menu_optional">
    <span>(Optional)</span>
  </TranslationProvider>
);

export const NotRequiredMax = ({ num }) => (
  <TranslationProvider translationKey="menu_optional_max" translationValues={{ num }}>
    <span>{`Select up to ${num} (Optional)`}</span>
  </TranslationProvider>
);

NotRequiredMax.propTypes = {
  num: PropTypes.number,
};

NotRequiredMax.defaultProps = {
  num: undefined,
};

export const Required = ({ num }) => (
  <TranslationProvider translationKey="menu_required" translationValues={{ num }}>
    <span>{`Select ${num} (Required)`}</span>
  </TranslationProvider>
);

Required.propTypes = {
  num: PropTypes.number,
};

Required.defaultProps = {
  num: undefined,
};

const Fulfilled = (num) => (
  <div className="Category__Fulfilled">
    <Required num={num} />
    <CheckMark />
  </div>
);

const UnFulfilled = (num) => (
  <div className="Category__UnFulfilled" role="alert" aria-live="assertive">
    <Required num={num} />
  </div>
);

const Optional = (num) => (
  <div className="Category__NotRequired">
    {num ? <NotRequiredMax num={num} /> : <NotRequired />}
  </div>
);

const CategoryRequirements = ({
  fulfilled,
  num,
  optional,
}) => {
  if (optional && num) {
    return Optional(num);
  }
  if (optional) {
    return Optional();
  }
  return (fulfilled ? Fulfilled(num) : UnFulfilled(num));
};

CategoryRequirements.propTypes = {
  fulfilled: PropTypes.bool,
  num: PropTypes.number,
  optional: PropTypes.bool,
};

CategoryRequirements.defaultProps = {
  fulfilled: false,
  num: undefined,
  optional: false,
};

export default CategoryRequirements;
